export const SeasonTypeConst = {
  past: 0,
  current: 1,
  future: 2,
};
